import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useNavigate } from 'react-router-dom';

export const useAuthErrorHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthError = (event: any) => {
      // Check for Supabase auth errors in console
      if (event.detail?.error?.name === 'AuthApiError') {
        const error = event.detail.error;
        
        // Handle refresh token errors
        if (error.code === 'refresh_token_not_found') {
          console.warn('Auth session expired, redirecting to login');
          navigate('/login');
        }
        
        // Handle other auth errors
        if (error.status === 400 || error.status === 401) {
          console.warn('Auth error detected, may need to re-authenticate');
        }
      }
    };

    // Never monkey-patch console.error: overlapping installs can chain (or
    // self-reference) wrappers and blow the call stack with
    // "RangeError: Maximum call stack size exceeded" on the next log.
    // Supabase already broadcasts auth state, so listen to that instead.
    const PROTECTED = ['/account', '/courier', '/admin', '/partner', '/support-portal'];
    const { data: sub } = supabase.auth.onAuthStateChange((event, session) => {
      if (event !== 'SIGNED_OUT' || session) return;
      // Only bounce to login from areas that actually require a session —
      // signing out on a public page must not hijack navigation.
      if (!PROTECTED.some((p) => window.location.pathname.startsWith(p))) return;
      handleAuthError({ detail: { error: { name: 'AuthApiError', code: 'refresh_token_not_found' } } });
    });

    return () => {
      sub.subscription.unsubscribe();
    };
  }, [navigate]);
};
